/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */
// ============================================
// MEGA MENU FOOTER CTA - Shop All Parts Link
// ============================================

(function() {
  'use strict';
  
  function addShopAllPartsLink() {
    // Find ALL navigation items
    const navItems = document.querySelectorAll('.nav-bar__item');
    
    navItems.forEach(function(item) {
      const link = item.querySelector('.nav-bar__link');
      
      // Only proceed if this is EXACTLY the PARTS link
      if (!link) return;
      
      const linkText = link.textContent.trim().toUpperCase();
      
      // Must be EXACTLY "PARTS"
      if (linkText !== 'PARTS') return;
      
      // Find the mega menu container
      const megaMenu = item.querySelector('.mega-menu');
      if (!megaMenu) return;
      
      // Check if already added
      if (megaMenu.querySelector('.mega-menu__footer-cta')) return;
      
      // Create the footer CTA
      const footerCTA = document.createElement('div');
      footerCTA.className = 'mega-menu__footer-cta';
      footerCTA.innerHTML = '<a href="/collections/all">Shop All Parts →</a>';
      
      // Add it AFTER the .mega-menu__inner (as a sibling, not inside)
      const inner = megaMenu.querySelector('.mega-menu__inner');
      if (inner && inner.nextSibling) {
        megaMenu.insertBefore(footerCTA, inner.nextSibling);
      } else if (inner) {
        megaMenu.appendChild(footerCTA);
      }
      
      console.log('✅ Shop All Parts link added');
    });
  }
  
  // Run on hover
  document.addEventListener('mouseenter', function(e) {
    if (e.target && e.target.closest && e.target.closest('.nav-bar__item')) {
      addShopAllPartsLink();
    }
  }, true);
  /* ============================
   STICKY ATC - Warehouse Theme
   ============================ */
(function(){
  function init(){
    // Sélecteurs multiples pour trouver le bouton ATC dans Warehouse
    var paymentContainer = document.querySelector('.product-form__payment-container');
    if(!paymentContainer) return;

    var btn = paymentContainer.querySelector('button[type="submit"]')
      || paymentContainer.querySelector('[name="add"]')
      || paymentContainer.querySelector('.button--primary')
      || document.querySelector('form[action*="/cart/add"] button[type="submit"]');
    if(!btn) return;

    // Injection CSS
    var s=document.createElement('style');
    s.textContent=
      '.sticky-atc-bar{display:none;pointer-events:none}'+
      '@media(max-width:1199px){'+
        '.sticky-atc-bar{display:block;position:fixed;bottom:0;left:0;right:0;z-index:999;'+
        'background:var(--secondary-background,#fff);border-top:1px solid var(--border-color,#e0e0e0);'+
        'padding:12px 20px;box-shadow:0 -2px 10px rgba(0,0,0,.12);'+
        'transform:translateY(100%);transition:transform .3s ease;pointer-events:none}'+
        '.sticky-atc-bar.is-visible{transform:translateY(0);pointer-events:auto}'+
        '.sticky-atc-bar .button,.sticky-atc-bar button{width:100%;margin:0}'+
        '.sticky-atc-bar .shopify-payment-button{display:none}'+
        'body.sticky-atc-active{padding-bottom:80px}'+
      '}';
    document.head.appendChild(s);

    // Création barre sticky
    var bar=document.createElement('div');
    bar.className='sticky-atc-bar';
    bar.setAttribute('aria-hidden','true');
    var clone=btn.cloneNode(true);
    clone.removeAttribute('disabled');
    bar.appendChild(clone);
    document.body.appendChild(bar);

    // Clic sur le clone → déclenche l'original
    clone.addEventListener('click',function(e){
      e.preventDefault();
      e.stopPropagation();
      btn.click();
    });

    // Synchroniser le texte et l'état disabled quand la variante change
    var syncBtn = function(){
      clone.textContent = btn.textContent;
      clone.disabled = btn.disabled;
      if(btn.disabled){
        clone.classList.add('button--disabled');
      } else {
        clone.classList.remove('button--disabled');
      }
    };

    // Observer les changements du bouton original (variante change, sold out, etc.)
    new MutationObserver(syncBtn).observe(btn,{childList:true,attributes:true,characterData:true,subtree:true});

    // IntersectionObserver pour afficher/masquer
    new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        var show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', !show);
        document.body.classList.toggle('sticky-atc-active', show);
      });
    },{threshold:0}).observe(paymentContainer);

    console.log('[Sticky ATC] Initialisé avec succès');
  }

  // Attendre que le DOM soit prêt + petit délai pour les apps tierces
  function ready(){
    if(document.readyState==='loading'){
      document.addEventListener('DOMContentLoaded',function(){ setTimeout(init,500); });
    } else {
      setTimeout(init,500);
    }
  }
  ready();
})();
  
})();

// Fix: Vitals tabs - lazy load YouTube iframes
// MutationObserver used because Vitals injects tab content
// AFTER DOMContentLoaded - iframes don't exist yet at that point.
(function() {
  function stripAndWatch() {
    document.querySelectorAll('.vt-tab-content:not(.current) iframe').forEach(function(iframe) {
      if (iframe.src && iframe.src.includes('youtube') && !iframe.hasAttribute('data-src')) {
        iframe.setAttribute('data-src', iframe.src);
        iframe.src = 'about:blank';
      }
    });

    document.querySelectorAll('li.vt-tab-link').forEach(function(tab) {
      if (tab.dataset.iframeListenerAdded) return;
      tab.dataset.iframeListenerAdded = 'true';
      tab.addEventListener('click', function() {
        setTimeout(function() {
          document.querySelectorAll('.vt-tab-content.current iframe[data-src]').forEach(function(iframe) {
            iframe.src = iframe.getAttribute('data-src');
            iframe.removeAttribute('data-src');
          });
        }, 150);
      });
    });
  }

  var observer = new MutationObserver(function() {
    if (document.querySelector('.vt-tab-content')) {
      observer.disconnect();
      stripAndWatch();
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
})();
/* ============================================================
   OGM — Breadcrumb 3 niveaux
   ============================================================ */
(function () {
  'use strict';
  const STORAGE_KEY = 'ogm_bc_v1';

  const NAV_MAP = {
    // ── PARTS > Bike Protections ──────────────────────────────
    'crash-bars':                     { mid: { title: 'Bike Protections',  url: '/collections/bike-protections' }, top: { title: 'Parts', url: '/collections/all' } },
    'crash-bars-replacement-parts':   { mid: { title: 'Bike Protections',  url: '/collections/bike-protections' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > Body Parts ────────────────────────────────────
    'fairings':                       { mid: { title: 'Body Parts', url: '/collections/body-parts' }, top: { title: 'Parts', url: '/collections/all' } },
    'fenders':                        { mid: { title: 'Body Parts', url: '/collections/body-parts' }, top: { title: 'Parts', url: '/collections/all' } },
    'covers':                         { mid: { title: 'Body Parts', url: '/collections/body-parts' }, top: { title: 'Parts', url: '/collections/all' } },
    'dash-gauge-block-off-plates':    { mid: { title: 'Body Parts', url: '/collections/body-parts' }, top: { title: 'Parts', url: '/collections/all' } },
    'hardware-accessories':           { mid: { title: 'Body Parts', url: '/collections/body-parts' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > Hand Controls ─────────────────────────────────
    'risers':                         { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'handlebars':                     { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'triple-trees':                   { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'pull-back-plates':               { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'instruments-and-gauges':         { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'cables-and-harnesses':           { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'throttle-and-grips':             { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'hand-controls-accessories':      { mid: { title: 'Hand Controls', url: '/collections/hand-controls' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > Foot Controls ─────────────────────────────────
    'brake-pedals':                   { mid: { title: 'Foot Controls', url: '/collections/foot-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'floorboards':                    { mid: { title: 'Foot Controls', url: '/collections/foot-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'foot-pegs':                      { mid: { title: 'Foot Controls', url: '/collections/foot-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'shifters':                       { mid: { title: 'Foot Controls', url: '/collections/foot-controls' }, top: { title: 'Parts', url: '/collections/all' } },
    'foot-control-replacement-parts': { mid: { title: 'Foot Controls', url: '/collections/foot-controls' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > Suspensions ───────────────────────────────────
    'fork-braces':                    { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'fork-tubes':                     { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'inverted-front-ends':            { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'steering-damper':                { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'suspension-mounts-and-accessories': { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'front-suspension':               { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'rear-suspension':                { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },
    'extensions':                     { mid: { title: 'Suspensions', url: '/collections/suspensions' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > Braking ───────────────────────────────────────
    'big-brake-kit':                  { mid: { title: 'Braking', url: '/collections/braking' }, top: { title: 'Parts', url: '/collections/all' } },
    'braking-mounts':                 { mid: { title: 'Braking', url: '/collections/braking' }, top: { title: 'Parts', url: '/collections/all' } },
    'calipers':                       { mid: { title: 'Braking', url: '/collections/braking' }, top: { title: 'Parts', url: '/collections/all' } },
    'master-cylinders':               { mid: { title: 'Braking', url: '/collections/braking' }, top: { title: 'Parts', url: '/collections/all' } },
    'rotors-pads-and-hardware':       { mid: { title: 'Braking', url: '/collections/braking' }, top: { title: 'Parts', url: '/collections/all' } },
    'brake-lines-and-hoses':          { mid: { title: 'Braking', url: '/collections/braking' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > LED Lighting ──────────────────────────────────
    'headlights':                     { mid: { title: 'LED Lighting', url: '/collections/led-lighting' }, top: { title: 'Parts', url: '/collections/all' } },
    'turn-signals-and-tail-lights':   { mid: { title: 'LED Lighting', url: '/collections/led-lighting' }, top: { title: 'Parts', url: '/collections/all' } },
    'conversion-kits':                { mid: { title: 'LED Lighting', url: '/collections/led-lighting' }, top: { title: 'Parts', url: '/collections/all' } },
    'light-bar-and-accessories':      { mid: { title: 'LED Lighting', url: '/collections/led-lighting' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── PARTS > Seats ─────────────────────────────────────────
    'seats':                          { mid: { title: 'Seats', url: '/collections/seating' }, top: { title: 'Parts', url: '/collections/all' } },
    'seat-screws':                    { mid: { title: 'Seats', url: '/collections/seating' }, top: { title: 'Parts', url: '/collections/all' } },

    // ── TODO : Upgrade Kits, Apparel, Accessories & Gifts ─────
  };

  // ── Capture sur page collection ───────────────────────────
  const colMatch = window.location.pathname.match(/^\/collections\/([\w-]+)\/?$/);
  if (colMatch) {
    const handle = colMatch[1];
    if (handle && handle !== 'all') {
      const h1 = document.querySelector('.collection__title, h1');
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
        handle: handle,
        title:  h1 ? h1.textContent.trim() : handle,
        url:    '/collections/' + handle
      }));
    }
  }

  // ── Injection sur page produit ────────────────────────────
  const breadcrumb = document.querySelector('[data-breadcrumb]');
  if (!breadcrumb || breadcrumb.getAttribute('data-is-product') !== 'true') return;

  const elTop    = document.getElementById('bc-top');
  const elTopLnk = document.getElementById('bc-top-link');
  const elMid    = document.getElementById('bc-mid');
  const elMidLnk = document.getElementById('bc-mid-link');
  const elSubLnk = document.getElementById('bc-sub-link');

  const stored = sessionStorage.getItem(STORAGE_KEY);
  if (!stored) return;

  let col;
  try { col = JSON.parse(stored); } catch (e) { return; }

  if (elSubLnk) {
    elSubLnk.href        = col.url;
    elSubLnk.textContent = col.title;
  }

  const map = NAV_MAP[col.handle];
  if (!map) return;

  if (map.top && elTop && elTopLnk) {
    elTopLnk.href        = map.top.url;
    elTopLnk.textContent = map.top.title;
    elTop.style.display  = '';
  }

  if (map.mid && elMid && elMidLnk) {
    elMidLnk.href        = map.mid.url;
    elMidLnk.textContent = map.mid.title;
    elMid.style.display  = '';
  }

})();
// ============================================
// OGM FREE SHIPPING UPSELL — Couche BOOT + logique pure (T03)
// ============================================
(function() {
  'use strict';

  // BOOT : lit la config serveur injectée par theme.liquid (window.OGM_UPSELL).
  // Si threshold est absent ou 0 (Rest of World / B2B), on sort immédiatement :
  // le module entier ne s'initialise pas et n'expose rien. C'est le early-exit
  // prévu au plan §4.3 — aucune boucle, aucun observer, aucun rendu sur ces marchés.
  const CONFIG = window.OGM_UPSELL;
  if (!CONFIG || !CONFIG.threshold) {
    return; // RoW / B2B : rien à faire
  }

  // computeGap : écart restant (en cents) entre le seuil de livraison gratuite et
  // le total panier courant. Positif = il manque ce montant ; <= 0 = seuil atteint.
  // Fonction pure (aucun DOM) → testable seule, c'est la base de selectProduct (T04).
  function computeGap(threshold, total) {
    return threshold - total;
  }

  // Namespace de debug : on expose la logique pure sur window pour pouvoir la
  // tester en console (DoD T03) et brancher le harnais de test à T05.
  // Les tickets suivants (T04 selectProduct, etc.) viendront s'accrocher ici.
  window.OGM_FS = {
    config: CONFIG,
    computeGap: computeGap
  };

})();
// ============================================
// OGM FREE SHIPPING UPSELL — selectProduct (T04, algorithme §6)
// ============================================
(function() {
  'use strict';

  // On s'accroche au namespace posé par le BOOT (T03). S'il n'existe pas
  // (RoW/B2B, ou config absente), on ne fait rien — cohérent avec l'early-exit.
  const FS = window.OGM_FS;
  if (!FS) return;

  const PRODUCTS = FS.config.products;

  // selectProduct : décide QUEL produit recommander pour un gap donné (en cents).
  // 100 % pur (aucun DOM). Reproduit les ladders §3 par dérivation depuis les prix,
  // sans aucun palier hardcodé : ajouter un produit = nouveau palier automatique.
  // Retourne :
  //   { type: "none" }                    → aucune carte à montrer
  //   { type: "single", item }            → une seule carte
  //   { type: "or", items: [a, b] }       → deux cartes séparées par « OU »
  function selectProduct(gap) {

    // --- Étape 1 : éligibilité + prix qualifiant -----------------------------
    // Un produit n'est éligible que s'il a au moins une variante in-stock (qty>0).
    // Son "prix qualifiant" = prix de sa variante in-stock la moins chère : c'est
    // le montant minimal que ce produit ajoute au panier (§1.2 / §1.3).
    let eligible = [];
    PRODUCTS.forEach(function(product) {
      const inStockVariants = product.variants.filter(function(v) { return v.qty > 0; });
      if (inStockVariants.length === 0) return; // tout en rupture → écarté
      const qualifyingPrice = Math.min.apply(null, inStockVariants.map(function(v) { return v.price; }));
      eligible.push({ product: product, qualifyingPrice: qualifyingPrice, inStockVariants: inStockVariants });
    });

    // --- Étape 2 : collapse casquette primaire / fallback --------------------
    // Snapback (cap_primary) et Trucker (cap_fallback) partagent le même slot (§1.4).
    // Si le Snapback est éligible, on retire le Trucker. Sinon le Trucker reste et
    // devient LA carte casquette. Le client ne voit jamais les deux. La relation est
    // lue depuis le champ `role` (data-driven, aucun handle codé en dur ici).
    const snapPresent = eligible.some(function(e) { return e.product.role === 'cap_primary'; });
    if (snapPresent) {
      eligible = eligible.filter(function(e) { return e.product.role !== 'cap_fallback'; });
    }

    // --- Étape 3 : candidats -------------------------------------------------
    // On ne garde que les produits dont le prix qualifiant ferme l'écart à lui seul
    // (prix >= gap). Garantit que l'ajout d'un seul produit franchit le seuil.
    const candidates = eligible.filter(function(e) { return e.qualifyingPrice >= gap; });

    // --- Étape 4 : conditions de masquage de la carte ------------------------
    // gap <= 0 (seuil déjà atteint) OU aucun candidat (gap plus grand que le produit
    // le plus cher) → pas de carte produit. La barre de progression, elle, reste
    // toujours visible (gérée ailleurs, §3) — ici on ne parle que de la carte.
    if (gap <= 0 || candidates.length === 0) {
      return { type: 'none' };
    }

    // --- Étape 5 : palier gagnant --------------------------------------------
    // Parmi les candidats, on prend le(s) moins cher(s) : le nudge le plus léger
    // qui franchit quand même le seuil.
    const winningPrice = Math.min.apply(null, candidates.map(function(e) { return e.qualifyingPrice; }));
    const selection = candidates.filter(function(e) { return e.qualifyingPrice === winningPrice; });

    // --- Étape 6 : type d'affichage ------------------------------------------
    // Un seul produit au palier gagnant → carte simple. Deux produits au même prix
    // (cas CAD 2995 : casquette OU Metal Sign) → affichage « OU » côte à côte.
    if (selection.length === 1) {
      return { type: 'single', item: selection[0] };
    }
    return { type: 'or', items: selection };
  }

  // Exposé sur le namespace pour le rendu (T08) et le harnais de test (T05).
  FS.selectProduct = selectProduct;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — i18n EN/FR + détection locale (T06)
// ============================================
(function() {
  'use strict';

  // S'accroche au namespace du BOOT (T03). Absent sur RoW/B2B → on ne fait rien.
  const FS = window.OGM_FS;
  if (!FS) return;

  // detectLang : déduit la langue d'affichage. On lit Shopify.locale en premier
  // (valeur runtime fiable, ex. "fr", "fr-CA", "en"), avec repli sur l'attribut
  // lang du <html>. On ne garde que le radical : tout ce qui commence par "fr"
  // → français, sinon anglais (défaut sûr). Le marché (CA/US) n'impose pas la
  // langue : un client CA peut naviguer en anglais et vice-versa.
  function detectLang() {
    let raw = '';
    if (window.Shopify && Shopify.locale) {
      raw = String(Shopify.locale);
    } else if (document.documentElement.lang) {
      raw = document.documentElement.lang;
    }
    return raw.toLowerCase().indexOf('fr') === 0 ? 'fr' : 'en';
  }

  // Dictionnaire bilingue. ⚠️ WORDING = PLACEHOLDER (décision §8) : la structure
  // des clés et la présence EN+FR sont finales, mais les textes exacts seront
  // arrêtés en Phase 3 une fois les composants visibles à l'écran. Tokens
  // d'interpolation : {amount} = montant restant formaté, {product} = titre produit.
  const STRINGS = {
    en: {
      bar_remaining: 'Only {amount} away from free shipping',
      bar_unlocked:  "You've unlocked free shipping!",
      card_heading:  'Add {product} to unlock free shipping',
      add_to_cart:   'Add to cart',
      select_size:   'Select a size',
      select_color:  'Select a color',
      card_nudge:   "Please don't pay for shipping",
      or_separator:  'OR'
    },
    fr: {
      bar_remaining: 'Plus que {amount} pour la livraison gratuite',
      bar_unlocked:  'Livraison gratuite débloquée !',
      card_heading:  'Ajoutez {product} pour débloquer la livraison gratuite',
      add_to_cart:   'Ajouter au panier',
      select_size:   'Choisir une taille',
      select_color:  'Choisir une couleur',
      card_nudge:   'Pourquoi payer pour la livraison?',
      or_separator:  'OU'
    }
  };

  const LANG = detectLang();

  // t : retourne la chaîne traduite pour `key`, en substituant les tokens fournis
  // dans `params` (ex. t('bar_remaining', { amount: '12,00 $' })). Si la clé est
  // inconnue, renvoie la clé brute (visible = facile à repérer en debug).
  function t(key, params) {
    let str = (STRINGS[LANG] && STRINGS[LANG][key]) || key;
    if (params) {
      Object.keys(params).forEach(function(k) {
        str = str.replace('{' + k + '}', params[k]);
      });
    }
    return str;
  }

  // Exposé pour les composants de rendu (T07 barre, T08 carte).
  FS.lang = LANG;
  FS.t = t;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — renderBar Composant 1 (T07)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS) return;

  // formatMoney : cents → chaîne devise localisée. Utilise Intl avec la devise du
  // marché (CAD/USD) et la langue active. 'narrowSymbol' force "$" plutôt que "CA$".
  // Repli manuel si Intl échoue. Réutilisé par la carte produit (T08).
  function formatMoney(cents) {
    const cur = FS.config.currency;
    const locale = FS.lang === 'fr' ? 'fr-CA' : (FS.config.market === 'US' ? 'en-US' : 'en-CA');
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency', currency: cur, currencyDisplay: 'narrowSymbol'
      }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' $';
    }
  }

  // renderBar : CONSTRUIT le nœud de la barre de progression (Composant 1) pour un
  // gap donné (cents) et le retourne. Pur builder, sans insertion DOM — c'est mount()
  // (T09) qui décidera insérer vs mettre à jour. Calqué sur la barre .inventory-bar
  // des pages produits (track 4px arrondi + remplissage vert animé).
  //   - pct rempli = (seuil - gap) / seuil, borné 0–100
  //   - gap > 0  → texte "Plus que {montant}…"  | gap <= 0 → texte "débloqué" + barre pleine
  function renderBar(gap) {
    const threshold = FS.config.threshold;
    const pct = Math.max(0, Math.min(100, ((threshold - gap) / threshold) * 100));
    const unlocked = gap <= 0;
    const label = unlocked
      ? FS.t('bar_unlocked')
      : FS.t('bar_remaining', { amount: formatMoney(gap) });

    const el = document.createElement('div');
    el.id = 'ogm-shipping-bar';
    el.className = 'ogm-shipping-bar' + (unlocked ? ' ogm-shipping-bar--unlocked' : '');

    // Label en textContent (jamais innerHTML) : sûr même si le wording final contient
    // des caractères spéciaux. La piste + le remplissage sont du markup statique.
    const p = document.createElement('p');
    p.className = 'ogm-shipping-bar__label';
    p.textContent = label;

    const track = document.createElement('div');
    track.className = 'ogm-shipping-bar__track';
    const fill = document.createElement('span');
    fill.className = 'ogm-shipping-bar__progress';
    fill.style.width = pct + '%';
    track.appendChild(fill);

    el.appendChild(p);
    el.appendChild(track);
    return el;
  }

  // Exposé pour mount (T09) et réutilisation du formatteur par la carte (T08).
  FS.formatMoney = formatMoney;
  FS.renderBar = renderBar;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — renderCard Composant 2 (T08)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS) return;

  // buildTile : construit une "tuile" produit (image, prix, sélecteur, bouton ajouter)
  // pour un item issu de selectProduct. showTitle=true affiche le titre dans la tuile
  // (utilisé en layout OU où il n'y a pas d'en-tête commune).
  //   - variants = inStockVariants UNIQUEMENT (déjà filtré par selectProduct §6) →
  //     le sélecteur n'expose jamais une taille/couleur en rupture.
  //   - variante par défaut = la moins chère in-stock (celle qui qualifie le gap).
  //   - changer de variante met à jour le prix affiché ET l'id sur le bouton.
  function buildTile(item, showTitle) {
    const product = item.product;
    const variants = item.inStockVariants;

    // défaut = variante in-stock la moins chère
    let sel = variants[0];
    variants.forEach(function(v) { if (v.price < sel.price) sel = v; });

    const tile = document.createElement('div');
    tile.className = 'ogm-upsell-card__tile';

    const img = document.createElement('img');
    img.className = 'ogm-upsell-card__img';
    img.src = product.image;
    img.alt = product.title;
    img.loading = 'lazy';
    tile.appendChild(img);

    if (showTitle) {
      const h = document.createElement('p');
      h.className = 'ogm-upsell-card__title';
      h.textContent = product.title;
      tile.appendChild(h);
    }

    const price = document.createElement('p');
    price.className = 'ogm-upsell-card__price';
    price.textContent = FS.formatMoney(sel.price);
    tile.appendChild(price);

    // Sélecteur de variante seulement si le produit a une option (Size/Color).
    // aria-label localisé pour l'accessibilité. Pas d'option vide : une variante
    // valide est toujours sélectionnée → le bouton ajouter a toujours un id valide.
    let select = null;
    if (product.option) {
      select = document.createElement('select');
      select.className = 'ogm-upsell-card__select';
      select.setAttribute('aria-label',
        product.option === 'Color' ? FS.t('select_color') : FS.t('select_size'));
      variants.forEach(function(v) {
        const o = document.createElement('option');
        o.value = v.id;
        o.textContent = v.title;
        if (v === sel) o.selected = true;
        select.appendChild(o);
      });
      tile.appendChild(select);
    }

    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'ogm-upsell-card__add';
    btn.textContent = FS.t('add_to_cart');
    btn.setAttribute('data-variant-id', sel.id);
    tile.appendChild(btn);

    // À chaque changement de variante : reflète le nouveau prix + le nouvel id.
    if (select) {
      select.addEventListener('change', function() {
        const v = variants.filter(function(x) { return String(x.id) === select.value; })[0];
        if (!v) return;
        price.textContent = FS.formatMoney(v.price);
        btn.setAttribute('data-variant-id', v.id);
      });
    }

    // Clic ajouter → délégué à addToCart (défini à T16). Guard : no-op tant que
    // cette couche n'existe pas, donc T08 reste testable seul sans rien casser.
    btn.addEventListener('click', function() {
      const id = parseInt(btn.getAttribute('data-variant-id'), 10);
      if (FS.addToCart) FS.addToCart(id);
    });

    return tile;
  }

  // renderCard : CONSTRUIT le nœud de la carte produit (Composant 2) à partir d'une
  // sélection. Retourne null si type "none" → mount() (T09) saura alors retirer la
  // carte existante. Layout "or" = deux tuiles + séparateur « OU » (§1.5).
  function renderCard(selection) {
    if (!selection || selection.type === 'none') return null; // carte cachée

    const wrap = document.createElement('div');
    wrap.id = 'ogm-upsell-card';
    wrap.className = 'ogm-upsell-card';

    if (selection.type === 'single') {
      const item = selection.item;
      // Ligne nudge en gras, au-dessus du titre (incite à ne pas payer la livraison).
      const nudge = document.createElement('p');
      nudge.className = 'ogm-upsell-card__nudge';
      nudge.textContent = FS.t('card_nudge');
      wrap.appendChild(nudge);
      // Titre d'invitation existant (« Ajoutez X pour débloquer… »)
      const heading = document.createElement('p');
      heading.className = 'ogm-upsell-card__heading';
      heading.textContent = FS.t('card_heading', { product: item.product.title });
      wrap.appendChild(heading);
      wrap.appendChild(buildTile(item, false)); // titre déjà dans l'en-tête
    } else if (selection.type === 'or') {
      wrap.classList.add('ogm-upsell-card--or');
      wrap.appendChild(buildTile(selection.items[0], true));
      const sep = document.createElement('span');
      sep.className = 'ogm-upsell-card__or-sep';
      sep.textContent = FS.t('or_separator');
      wrap.appendChild(sep);
      wrap.appendChild(buildTile(selection.items[1], true));
    }
    return wrap;
  }

  FS.renderCard = renderCard;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — mount idempotent (T09)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS) return;

  // mount : pose/actualise les DEUX composants dans le conteneur d'ancrage fourni.
  // Idempotent (§5.7) : si un composant existe déjà (#ogm-shipping-bar / #ogm-upsell-card),
  // on REMPLACE son contenu in-place plutôt que d'ajouter un doublon. Robuste si Vitals
  // réécrit le TopContainer lors d'un refresh — un nouveau cycle ré-injecte proprement.
  //
  //   anchor   : élément hôte (à T13 = .Vtl-CartDrawer__Container-Content-TopContainer ;
  //              pour tester seul, n'importe quel conteneur bidon).
  //   gap      : écart restant en cents (computeGap, T03).
  //   selection: sortie de selectProduct(gap) (T04).
  //
  // Barre : TOUJOURS présente sur marché valide (même panier vide / seuil atteint).
  // Carte : présente seulement si selection != "none" ; sinon on retire l'existante.
  function mount(anchor, gap, selection) {
    if (!anchor) return;

    // --- Composant 1 : barre (toujours rendue) -------------------------------
    const newBar = FS.renderBar(gap);
    const oldBar = anchor.querySelector('#ogm-shipping-bar');
    if (oldBar) {
      // Mise à jour in-place : on transfère le nouveau contenu dans le nœud existant.
      // Garder le même nœud préserve l'animation CSS de la barre (transition width).
      oldBar.className = newBar.className;
      oldBar.replaceChildren.apply(oldBar, newBar.childNodes); // copie label + track
      // Re-applique la largeur (replaceChildren a déplacé le span déjà à la bonne %).
    } else {
      // Première insertion : la barre est le PREMIER enfant de l'ancre (sticky top).
      anchor.prepend(newBar);
    }

    // --- Composant 2 : carte (conditionnelle) --------------------------------
    const newCard = FS.renderCard(selection); // null si type "none"
    const oldCard = anchor.querySelector('#ogm-upsell-card');
    if (newCard) {
      if (oldCard) {
        oldCard.replaceWith(newCard); // remplace : la carte n'a pas d'animation à préserver
      } else {
        anchor.appendChild(newCard); // dernier enfant de l'ancre (sticky bottom)
      }
    } else if (oldCard) {
      oldCard.remove(); // seuil atteint ou aucun produit ne ferme l'écart → on enlève
    }
  }

  FS.mount = mount;

})();
// ============================================
// ============================================
// OGM FREE SHIPPING UPSELL — Adaptateur Vitals : détection ouverture (T10 — v3)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS) return;

  // SELECTORS : sélecteurs Vitals verrouillés (recon §5.3), centralisés.
  const SELECTORS = {
    container: '.Vtl-CartDrawer__Container',
    anchor:    '.Vtl-CartDrawer__Container-Content-TopContainer',
    products:  'section.Vtl-CartDrawerProducts',
    header:    'header.Vtl-CartDrawerHeader',
    footer:    '.Vtl-CartDrawer__Container-FooterContainer'
  };

  // SIGNAL D'ÉTAT : contrairement à --IsVisible (qui reste figée sur le Container
  // après la 1re création), Vitals ajoute/retire `window-no-scroll` sur le <body>
  // à chaque ouverture/fermeture (lock de scroll). C'est notre source de vérité,
  // confirmée par espionnage DOM. Le Container est créé en lazy à la 1re ouverture.
  const OPEN_BODY_CLASS = 'window-no-scroll';

  function getContainer() {
    return document.querySelector(SELECTORS.container);
  }

  // isOpen : lit la classe de lock sur le body (fraîche à chaque appel).
  function isOpen() {
    return document.body.classList.contains(OPEN_BODY_CLASS);
  }

  // onOpen : appelle cb à chaque transition fermé → ouvert. On observe la classe du
  // <body> (cible unique, stable, jamais recréée). Le garde `wasOpen` évite les
  // doubles déclenchements ; pas besoin de coalescer (mutations du body rares).
  function onOpen(cb) {
    let wasOpen = isOpen();
    if (wasOpen) cb(); // déjà ouvert au branchement

    const obs = new MutationObserver(function() {
      const openNow = isOpen();
      if (openNow && !wasOpen) cb();
      wasOpen = openNow;
    });
    obs.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  FS.adapter = {
    SELECTORS: SELECTORS,
    OPEN_BODY_CLASS: OPEN_BODY_CLASS,
    getContainer: getContainer,
    isOpen: isOpen,
    onOpen: onOpen
  };

})();
// ============================================
// OGM FREE SHIPPING UPSELL — Adaptateur Vitals : changements panier (T11, Observer B)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS || !FS.adapter) return;
  const SELECTORS = FS.adapter.SELECTORS;

  // touchesProducts : vrai si une mutation reflète un vrai changement de panier.
  // Couvre 3 cas, tous confirmés par recon DOM :
  //   1. mutation DANS la liste d'items (qty, prix, ajout/retrait d'une ligne)
  //   2. retrait/ajout du TopContainer lui-même (Vitals le détruit quand le panier
  //      se vide, et le recrée quand on rajoute un 1er produit)
  //   3. apparition/disparition de l'EmptyState (le message "panier vide")
  // Les cas 2 et 3 sont essentiels : au passage à vide, Vitals ANNIHILE le TopContainer
  // (donc la section produits) et insère EmptyState — sans jamais "modifier" la section.
  // Sans ça, vider le panier ne déclenchait aucun re-render (barre figée). Reste en
  // lecture seule : on ne fait que DÉTECTER, on n'écrit jamais dans ces nœuds.
  function touchesProducts(m) {
    const sel = SELECTORS.products;
    // cas 1 : mutation à l'intérieur de la liste d'items
    const el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
    if (el && el.closest && el.closest(sel)) return true;
    // cas 2 + 3 : un nœud-clé apparaît ou disparaît (liste, TopContainer, EmptyState)
    const KEY = /Vtl-CartDrawerProducts|Vtl-CartDrawer__Container-Content-TopContainer|Vtl-CartDrawerEmptyState/;
    const scan = function(nodes) {
      for (let i = 0; i < nodes.length; i++) {
        const n = nodes[i];
        if (n.nodeType !== 1) continue;
        if (KEY.test(n.className || '')) return true;          // le nœud lui-même
        if (n.querySelector && n.querySelector(sel)) return true; // ou il contient la liste
      }
      return false;
    };
    return scan(m.addedNodes) || scan(m.removedNodes);
  }

  // onCartChange : appelle cb (débounce 150ms) à chaque modif réelle du contenu panier
  // — ajout, retrait, changement de quantité. Lecture seule : on n'écrit jamais dans
  // la section produits. Le Container étant créé en lazy (confirmé T10), on attend son
  // apparition via le body avant de brancher l'observer dessus.
  function onCartChange(cb) {
    let timer = null;
    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(cb, 150); // débounce : une rafale de mutations = un seul cb
    }

    function attach(container) {
      const obs = new MutationObserver(function(muts) {
        // On ne planifie cb que si AU MOINS une mutation touche la liste d'items.
        for (let i = 0; i < muts.length; i++) {
          if (touchesProducts(muts[i])) { schedule(); return; }
        }
      });
      // childList + characterData seulement (PAS attributes) : on capte ajout/retrait
      // d'items et changements de texte (qty/prix), sans le spam de mutations de style
      // que Vitals émet en continu sur Container-Content.
      obs.observe(container, { childList: true, subtree: true, characterData: true });
    }

    const existing = FS.adapter.getContainer();
    if (existing) {
      attach(existing);
    } else {
      // Container pas encore monté : on attend son apparition. On observe UNIQUEMENT
      // les enfants directs du body (childList sans subtree) — Vitals monte le drawer
      // comme enfant direct du body. Sans subtree, on n'inonde plus le système d'events
      // du thème (event-observer-collector / _VariantPicker), ce qui cassait le
      // sélecteur de variante des pages produits. On se débranche dès qu'on a le Container.
      const boot = new MutationObserver(function() {
        const c = FS.adapter.getContainer();
        if (c) { boot.disconnect(); attach(c); }
      });
      boot.observe(document.body, { childList: true, subtree: true });
    }
  }

  FS.adapter.onCartChange = onCartChange;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — Adaptateur Vitals : mesure des offsets (T12)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS || !FS.adapter) return;
  const SELECTORS = FS.adapter.SELECTORS;

  // syncOffsets : mesure la hauteur RÉELLE du header et du footer Vitals au moment
  // de l'appel (getBoundingClientRect, donc valeur rendue exacte incluant paddings/
  // bordures), puis l'écrit en CSS var sur le Container. Nos composants sticky lisent
  // ces vars : la barre se cale sous le header (top), la carte au-dessus du footer
  // (bottom) — sans jamais les chevaucher, quelle que soit leur hauteur (qui varie
  // selon le contenu : promo, sous-totaux, taxes...).
  //
  // Mesuré à CHAQUE ouverture et à CHAQUE changement de panier (le footer grandit/
  // rétrécit quand le sous-total change), donc toujours synchro. Idempotent et sans
  // effet de bord visible : écrire une CSS var ne déclenche pas Observer B (qui
  // n'écoute que la section produits, pas les attributs du Container — confirmé T11).
  function syncOffsets() {
    const container = FS.adapter.getContainer();
    if (!container) return;

    const header = container.querySelector(SELECTORS.header)
                || document.querySelector(SELECTORS.header);
    const footer = container.querySelector(SELECTORS.footer)
                || document.querySelector(SELECTORS.footer);

    // Hauteur arrondie au pixel ; 0 si l'élément est absent (drawer minimal).
    const headerH = header ? Math.ceil(header.getBoundingClientRect().height) : 0;
    const footerH = footer ? Math.ceil(footer.getBoundingClientRect().height) : 0;

    container.style.setProperty('--ogm-header-h', headerH + 'px');
    container.style.setProperty('--ogm-footer-h', footerH + 'px');
  }

  FS.adapter.syncOffsets = syncOffsets;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — Couche CART : lecture du total panier (T14)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS) return;

  // fetchCart : lit le panier courant via l'API Ajax native de Shopify (GET /cart.js)
  // et résout avec le total en CENTS (cart.total_price est déjà en cents, devise du
  // marché courant sous Shopify Markets). Source de vérité du total — indépendante de
  // ce que Vitals affiche. C'est ce total qui alimente computeGap (T03).
  //   - credentials:'same-origin' : indispensable pour que le cookie de panier parte.
  //   - en cas d'échec réseau, on rejette : l'orchestration (T18) décidera quoi faire
  //     (typiquement : ne pas re-render plutôt que d'afficher un faux gap).
  function fetchCart() {
    return fetch('/cart.js', {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    }).then(function(res) {
      if (!res.ok) throw new Error('cart.js HTTP ' + res.status);
      return res.json();
    }).then(function(cart) {
      return cart.total_price; // cents
    });
  }

  FS.fetchCart = fetchCart;

})();
// ============================================
// ============================================
// OGM FREE SHIPPING UPSELL — Injection aux ancres Vitals (T13 — v2 : frères du Content)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS || !FS.adapter) return;
  const A = FS.adapter;

  // DÉCOUVERTE DOM (recon live) : le Container a 3 enfants directs — Header, Content
  // (la SEULE zone scrollable, overflowY:auto), Footer. Le "TopContainer" du plan §5.4
  // n'était PAS une bande au-dessus des produits : il EST le conteneur des produits,
  // dans le Content scrollable. Injecter dedans = la barre scrolle et recouvre les items.
  //
  // CORRECTIF : on insère nos composants comme FRÈRES du Content —
  //   barre  : juste AVANT Content (sous le header, au-dessus de la zone qui scrolle)
  //   carte  : juste APRÈS Content (au-dessus du footer)
  // Résultat : barre et carte hors du scroll → fixes nativement, zéro recouvrement,
  // zéro sticky, zéro offset à mesurer. Les produits scrollent entre les deux.

  // placeBar : insère/maj la barre comme frère AVANT le Content (idempotent).
  function placeBar(container, gap) {
    const content = container.querySelector('.Vtl-CartDrawer__Container-Content');
    if (!content) return;
    const newBar = FS.renderBar(gap);
    const oldBar = container.querySelector('#ogm-shipping-bar');
    if (oldBar) {
      oldBar.replaceWith(newBar); // remplace : pas de sticky à préserver
    } else {
      content.parentNode.insertBefore(newBar, content); // avant le Content
    }
  }

  // placeCard : insère/maj la carte dans le FOOTER Vitals, en PREMIER enfant —
  // donc collée juste au-dessus du bloc checkout (Vtl-CartDrawerCheckout), toujours
  // visible (le footer est position:fixed). Choix conversion : un push upsell doit
  // être vu à chaque fois, pas perdu sous le pli sur un panier court / mobile.
  // Retire la carte si selection est "none".
  function placeCard(container, selection) {
    const footer = container.querySelector('.Vtl-CartDrawer__Container-FooterContainer');
    if (!footer) return;
    const newCard = FS.renderCard(selection); // null si type "none"
    const oldCard = footer.querySelector('#ogm-upsell-card');
    if (newCard) {
      if (oldCard) {
        oldCard.replaceWith(newCard);
      } else {
        footer.insertBefore(newCard, footer.firstChild); // 1er enfant = au-dessus du checkout
      }
    } else if (oldCard) {
      oldCard.remove();
    }
  }

  let _gen = 0; // jeton de génération : seule la requête la plus récente s'applique

  // renderCycle : un cycle complet. Le Container étant lazy (T10), on retente si pas prêt.
  function renderCycle(attempt) {
    attempt = attempt || 0;
    const container = A.getContainer();
    if (!container || !container.querySelector('.Vtl-CartDrawer__Container-Content')) {
      if (attempt < 10) setTimeout(function() { renderCycle(attempt + 1); }, 50);
      return;
    }
    const myGen = ++_gen; // marque CETTE requête comme la plus récente
    FS.fetchCart().then(function(total) {
      if (myGen !== _gen) return; // un cycle plus récent a démarré → on abandonne (anti-stale)
      const gap = FS.computeGap(FS.config.threshold, total);
      placeBar(container, gap);                 // barre TOUJOURS (marché valide)
      placeCard(container, FS.selectProduct(gap)); // carte si selection != none
    }).catch(function(e) {
      console.warn('[OGM] fetchCart échec — rendu sauté', e);
    });
  }

  FS.renderCycle = renderCycle;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — addToCart + tracking attribut (T16 + T20)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS) return;

  // handleFromVariant : retrouve le handle du produit auquel appartient une
  // variante, en cherchant dans notre config (les 8 produits d'upsell).
  // Sert au tracking : on enregistre QUEL produit a été ajouté via le widget.
  function handleFromVariant(variantId) {
    const products = FS.config.products;
    for (let i = 0; i < products.length; i++) {
      for (let j = 0; j < products[i].variants.length; j++) {
        if (products[i].variants[j].id === variantId) return products[i].handle;
      }
    }
    return null;
  }

  // trackUpsell : écrit l'attribut de panier caché `_ogm_upsell` (underscore =
  // invisible client/admin ; Shopify Flow le lit quand même). Contenu = liste des
  // handles ajoutés via le widget, séparés par des virgules, sans doublon.
  // L'attribut voyage avec le panier jusqu'à la commande → Flow "Order fulfilled"
  // détecte sa présence et pose le tag CARTUPSELL. Best-effort : un échec de
  // tracking ne doit JAMAIS bloquer l'ajout au panier (d'où le .catch silencieux).
  function trackUpsell(variantId) {
    const handle = handleFromVariant(variantId);
    if (!handle) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const current = (cart.attributes && cart.attributes._ogm_upsell) || '';
        const list = current ? current.split(',') : [];
        if (list.indexOf(handle) !== -1) return; // déjà tracké, rien à faire
        list.push(handle);
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { _ogm_upsell: list.join(',') } })
        });
      })
      .catch(function(e) { console.warn('[OGM] tracking upsell échec (non bloquant)', e); });
  }

  // addToCart : ajoute la variante au panier via /cart/add.js, puis déclenche le
  // tracking. Pas de re-render manuel : Vitals rafraîchit sa liste seul après
  // l'ajout → Observer B capte → renderCycle recalcule. Le tracking (update.js)
  // ne touche que les attributs, pas les items → n'active pas Observer B (pas de boucle).
  function addToCart(variantId) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: variantId, quantity: 1 })
    }).then(function(res) {
      if (!res.ok) throw new Error('add.js HTTP ' + res.status);
      trackUpsell(variantId); // tracking APRÈS ajout réussi seulement
      return res.json();
    }).catch(function(e) {
      console.warn('[OGM] addToCart échec', e);
    });
  }

  FS.addToCart = addToCart;

})();
// ============================================
// OGM FREE SHIPPING UPSELL — Orchestration (T18)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS || !FS.adapter || !FS.renderCycle) return;
  const A = FS.adapter;

  // Garde d'init unique : empêche un double-câblage des observers si ce bloc
  // ré-exécute. Un seul jeu d'Observer A/B par session — rend impossible
  // l'empilement de déclencheurs qu'on a vu apparaître pendant les tests console.
  if (FS._orchestrated) return;
  FS._orchestrated = true;

  // Branche les deux déclencheurs sur le même cycle. renderCycle (T13) est idempotent
  // (mount ne duplique jamais) et protégé par jeton de génération (pas de rendu périmé),
  // donc même si onOpen et onCartChange tirent de façon rapprochée, le résultat est cohérent.
  A.onOpen(function() { FS.renderCycle(0); });
  A.onCartChange(function() { FS.renderCycle(0); });

})();
// ============================================
// OGM FREE SHIPPING UPSELL — Réconciliation du tracking (T21)
// ============================================
(function() {
  'use strict';

  const FS = window.OGM_FS;
  if (!FS || !FS.adapter) return;

  // Garde d'init unique : une seule réconciliation branchée par session
  // (même principe que _orchestrated dans T18).
  if (FS._reconcileWired) return;
  FS._reconcileWired = true;

  // variantToHandle : table variantId → handle, construite une fois depuis la
  // config. Sert à savoir quels produits d'upsell sont réellement dans le panier.
  const V2H = {};
  FS.config.products.forEach(function(p) {
    p.variants.forEach(function(v) { V2H[v.id] = p.handle; });
  });

  // reconcile : relit le panier complet, et purge de l'attribut _ogm_upsell tout
  // handle dont le produit n'est PLUS dans le panier. Ne fait que RETIRER, jamais
  // ajouter (l'ajout appartient au clic widget — T16/trackUpsell). Résultat :
  // l'attribut ne contient que des ventes upsell RÉELLES au moment de la commande,
  // pas de simples clics. N'écrit que si la liste a changé (zéro requête inutile).
  function reconcile() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        const current = (cart.attributes && cart.attributes._ogm_upsell) || '';
        if (!current) return; // rien à réconcilier

        // handles d'upsell réellement présents dans le panier en ce moment
        const inCart = {};
        (cart.items || []).forEach(function(item) {
          const h = V2H[item.variant_id];
          if (h) inCart[h] = true;
        });

        // on ne garde que les handles trackés ENCORE présents
        const kept = current.split(',').filter(function(h) { return inCart[h]; });
        const next = kept.join(',');
        if (next === current) return; // rien n'a changé → pas d'écriture

        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ attributes: { _ogm_upsell: next } }) // '' si plus rien
        });
      })
      .catch(function(e) { console.warn('[OGM] réconciliation tracking échec (non bloquant)', e); });
  }

  // Branchée sur chaque changement de panier (retrait, vidage, changement de qty).
  // onCartChange est déjà débouncé (150 ms) → une rafale = une seule réconciliation.
  FS.adapter.onCartChange(reconcile);

})();